<template>
  <div class="d-flex flex-wrap flex-md-nowrap mt-2 mt-md-0">
    <b-button
      :variant="variant"
      @click="showFields = !showFields"
      class="mb-2 mb-md-0"
    >
      {{ $t('users.export') }}
    </b-button>
    <div
      v-if="showFields"
      class="d-flex flex-wrap flex-md-nowrap ml-md-3"
    >
      <b-input
        :value="value"
        @input="(val) => $emit('input', val)"
        id="target_email"
        type="email"
        class="w-100 rounded mb-2 mb-md-0"
        style="height: 35px"
        name="target_email"
        placeholder="Enter recipient email"
      />
      <div class="d-flex align-items-center ml-4">
        <i
          v-if="value"
          class="far fa-file-excel fa-lg ml-1 mr-1 text-primary d-block"
        />
        <b-link
          :disabled="!value"
          @click="$emit('export')"
          style="width: 100px"
        >
          {{ $t('global.generate_send_on_email') }}
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportComponent',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showFields: false,
    }
  },
  computed: {
    variant: ({showFields}) => (showFields ? 'outline-info' : 'outline-primary')
  },  
}
</script>
